
import {Component} from 'argo-js/src/view';
const tpl = require('../templates/navigation.hbs');

export class Header extends Component {

  constructor(config) {
    super($.extend(true, {
      tpl: tpl,
      ui: {
        userAnonymous: '.user-anonymous',
        userLoggedIn: '.user-loggedin',
        brand: '.js-brand',
        logoutTime: '.logoutTime',
        loginName: '.loginName',
        navigationContainer: '#navigation',
        homeUrl: '.js-home-url'
      },
      events: {
        'click @brand': 'handleHome'
      },
    }, config));
  }

  onInit() {
    this.handleUserAuth();
    this.attachHtml();
  }

  /**
   * redner the template
   * @returns {jQuery.fn.init|*|jQuery|HTMLElement}
   */
  render() {
    let items = this.renderItem();
    return $(items);
  }

  /**
   * get the html
   */
  renderItem() {
    const menuItems = {
      username: this.app.user.get('name')
    };

    return this.config.tpl($.extend({}, menuItems));
  }

  /**
   * parte the html into the container if the user logged in
   */
  attachHtml() {
    let $html = this.render();
    if(this.app.user.isAuthorized()) {
      this.ui.navigationContainer.replaceWith($html);
      this._rebind();
    }
  }

  handleUserAuth() {

    this.ui.homeUrl.attr('href', this.app.getHomePath());
    let loggedIn = this.app.user.isAuthorized();
    let path = (window.location.pathname === '/auth/login.html' ||
                window.location.pathname === '/auth/forgot-password.html');

    if(!loggedIn && !path) {
      this.app.redirect( this.app.getHomePath());
    }

  }

  handleHome() {
    let target = this.ui.brand.data(this.app.user.isAuthorized() ? 'target-user' : 'target');
    if (!target) {
      this.app.toHome();
    }
    else {
      this.app.redirect(target);
    }
  }

  onLogout(e) {
    e.preventDefault();
    this.app.user
      .logout()
      .then(() => this.app.toHome());
  }

}